function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Nav, Icon } from "@dpdgroupuk/mydpd-ui";

const Profile = ({
  title,
  header,
  onSelect,
  className,
  links
}) => {
  return /*#__PURE__*/React.createElement(Nav.Dropdown, {
    className: classNames("mydpd-nav-user-menu", className),
    title: title,
    drop: "down",
    alignRight: true,
    onSelect: onSelect
  }, /*#__PURE__*/React.createElement(Nav.Dropdown.Header, null, header), /*#__PURE__*/React.createElement(Nav.Dropdown.Divider, null), links.map((link, index) => /*#__PURE__*/React.createElement(Nav.Dropdown.Item, {
    key: index,
    as: "div"
  }, /*#__PURE__*/React.createElement(Nav.Link, _extends({
    key: index
  }, link)))));
};

Profile.defaultProps = {
  title: /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Icon.Person, {
    size: 24,
    color: "#414042"
  })),
  header: "Welcome, User"
};
Profile.propTypes = {
  title: PropTypes.node,
  header: PropTypes.node,
  className: PropTypes.string,
  ...Nav.Dropdown.propTypes
};
export default Profile;